<template>
  <div>
    <div v-if="loading" class="blackbox-loader"></div>

    <div v-else>
      <v-card outlined> 
        <v-card-text>
          <v-container v-if="userRole == 'superadmin' || companyCallCenter" grid-list-md class="pa-0 mb-4" fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <h1 class="tab-title" :style="{color: $vuetify.theme.themes[theme].text}">Call Center Afspraakwidget</h1>
              </v-flex>
              <v-flex md6 xs12>
                <v-alert
                  class="ma-0 mt-1 pa-2"
                  type="info"
                  color="info"
                  >
                  <span class="white--text">Pas beschikbaarheid aan om telefoongesprekken te ontvangen van klanten.</span>
                </v-alert>
                <v-switch
                  class="pa-0 ma-0 my-4"
                  :color="companyPrimaryColor"
                  label="Beschikbaar om gebeld te worden."
                  hide-details
                  v-model="callcenterOnline"
                  v-on:change="changeOnlineStatus()"
                ></v-switch>
              </v-flex>
          </v-layout>
        </v-container>

          <v-container grid-list-md class="pa-0" fluid>
            <v-layout row wrap>
              <v-flex md6 xs12>
                <h1 class="tab-title" :style="{color: $vuetify.theme.themes[theme].text}">Account gegevens</h1>
              </v-flex>
              <v-flex md6 xs12>
                <div style="display: inline-block; float: right;">
                  <v-btn rounded :color="companySecondaryColor" class="modal-button-next" :dark="changed" :loading="updateUserInfoBusy" :disabled="!changed" :depressed="!changed" @click="updateUserInfo()">Wijzigingen opslaan<v-icon right dark>arrow_forward_ios</v-icon></v-btn>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row wrap>
              <v-flex md6 xs12>
                <v-text-field
                  class="pt-4"
                  label="Voornaam"
                  v-model="userData.firstName"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  required
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="pt-4"
                  label="Achternaam"
                  v-model="userData.lastName"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  required
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="pt-4"
                  label="E-mail"
                  disabled
                  readonly
                  v-model="userData.email"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  required
                  outlined
                ></v-text-field>
              </v-flex>
              <v-flex md6 xs12>
                <v-text-field
                  class="pt-4"
                  disabled
                  readonly
                  label="Telefoonnummer Call Center"
                  v-model="userData.callTo"
                  :color="companyPrimaryColor"
                  :background-color="$vuetify.theme.themes[theme].menu"
                  hide-details
                  required
                  outlined
                ></v-text-field>
              </v-flex>
                

              <v-flex xs12 class="mt-4">
                <h3 :style="{color: $vuetify.theme.themes[theme].text}" >Wachtwoord wijzigingen</h3>
              </v-flex>

              <v-flex md6 xs12>
                <v-card outlined :color="$vuetify.theme.themes[theme].menuhover" >
                  <v-card-text>
                    <v-text-field
                      label="Nieuw wachtwoord"
                      v-model="password"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      required
                      outlined
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      counter
                    ></v-text-field>
                                
                    <v-text-field
                      v-if="password"
                      class="pt-2"
                      label="Wachtwoord bevestigen"
                      v-model="passwordConfirm"
                      :color="companyPrimaryColor"
                      :background-color="$vuetify.theme.themes[theme].menu"
                      hide-details
                      required
                      outlined
                      :type="showPassword ? 'text' : 'password'"
                      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showPassword = !showPassword"
                      counter
                    ></v-text-field>
                    <v-alert
                      class="ma-0 mt-2 pa-2"
                      type="warning"
                      color="warning"
                      outlined
                      v-if="passwordNotEqual"
                      >
                      <span :style="{color: $vuetify.theme.themes[theme].text}">Wachtwoorden komen niet overeen.</span>
                    </v-alert>
                    
                    <v-btn v-if="password" class="mt-4" rounded :color="companySecondaryColor" block :dark="newPassword" :loading="updatePasswordBusy" :disabled="!newPassword" :depressed="!newPassword" @click="changePassword()">Wachtwoord wijzigen</v-btn>

                  </v-card-text>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>

      </v-card>
    </div>


  </div>
</template>


<script>
import db from "../firebase/init";
import _lodash from "lodash";
import axios from "axios";

export default {
  name: "account",
  data: () => ({
    updateUserInfoBusy: false,
    companyPages: -1,
    loading: true,
    userData: null,
    userDataOriginal: null,
    password: "",
    passwordConfirm: "",
    showPassword: false,
    updatePasswordBusy: false,
    callcenterOnline: null
  }),

  created() {
     this.loadUserData();
  },

  methods: {
    loadUserData() {
      this.loading = true
      db.collection("users")
        .doc(this.$store.state.userName).get()
        .then(doc => {
          let userdata = doc.data()
          userdata.id = doc.id;
          this.userData = userdata
          this.userDataOriginal = _.cloneDeep(this.userData )
          this.callcenterOnline = doc.data().callActive 
        })
        .then(()=>{
          this.loading = false
        })
    },
    updateUserInfo(){
      this.updateUserInfoBusy = true
      db.collection("users")
        .doc(this.userData.id)
        .set({
          firstName: this.userData.firstName,
          lastName: this.userData.lastName
        }, { merge: true })
        .then(()=>{
          db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version, 
              pillarrrVersion: this.$store.state.version,
              action: "Account bewerkt: " + this.userFirstName + " " + this.userLastName,
              extra:
                "<b>ORIGINELE GEGEVENS</b><br>" +
                "Voornaam: " + this.userData.firstName + "<br>" + 
                "Achternaam: " + this.userData.lastName + "<br><br>" + 
                "<b>AANGEPASTE GEGEVENS</b>" +
                "Voornaam: " + this.userDataOriginal.firstName + "<br>" + 
                "Achternaam: " + this.userDataOriginal.lastName
          })
        })
        .then(()=>{
          this.userDataOriginal.firstName = _.cloneDeep(this.userData.firstName)
          this.userDataOriginal.lastName = _.cloneDeep(this.userData.lastName)
          this.updateUserInfoBusy = false
        })
        .catch(error =>{
          console.error("Account bijwerken niet gelukt: ", error)
           this.updateUserInfoBusy = false
        })
    },

    changeOnlineStatus(){
      if(this.callcenterOnline == false){
        this.$store.dispatch("onlineCallStatus", false);
        db.collection("users")
          .doc(this.userData.id)
          .set({
            callActive: false
          }, { merge: true })
      } else{
        this.$store.dispatch("onlineCallStatus", true);
        db.collection("users")
          .doc(this.userData.id)
          .set({
            callActive: true
          }, { merge: true })
      }
    },

    changePassword(){
      this.updatePasswordBusy = true
      var config = {
        method: 'post',
        url: 'https://europe-west1-dev-app-137723.cloudfunctions.net/auth',
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        data : {
          type: 'changePassword',
          uid: this.userData.user_id,
          password: this.password
        }
      };
      axios(config)
      .then(()=> {
        this.updatePasswordBusy = false
        this.passwordConfirm = null;
        this.password = null;
      }).catch(error=> {
        console.error("Password updated niet gelukt: ", error)
        this.updatePasswordBusy = false
      });
    }
  },

  computed: {
    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
    companyCallCenter() {
      if (_.includes(this.companyPackages, "callcenter")) {
        return true;
      } else {
        return false;
      }
    },
    passwordNotEqual(){
      if(this.passwordConfirm){
        if(this.passwordConfirm == this.password){
          return false
        } else{
          return true
        }
      } else{
        return false
      }
    },
    newPassword(){
      if(this.password && this.passwordConfirm == this.password){
        return true
      } else{
        return false
      }
    },
    changed() {
      if (_.isEqual(this.userDataOriginal, this.userData)) {
        return false;
      } else {
        return true;
      }
    },
  }
};
</script>
<style>
.company-package{
  display: list-item;
  margin: 0;
}

.company-package-list{
  padding: 5px 0;
}
</style>
